import React, { Component } from 'react'
import { connect } from "react-redux";
import classnames from 'classnames';
import uuid from 'uuid';

import Input from './shared/Input';
import Button from './shared/Button';
import { Link } from "react-router-dom";
import { get, some } from 'lodash'
import profileApi from '../api/auth'
import { profileInvalidate } from '../store/profile/actions'
import validate from '../utils/validate'
import { isEmpty } from 'lodash'

import baseStyles from 'custom/base.styl';
// import { LoginPageTitle, LoginPageSubTitle } from 'custom/LoginPageText';
import { RegistrationPageTitle, RegistrationPageSubTitle } from 'custom/RegistrationPageText';
import { trackValues } from './../tracker';
import { trackSiteId } from './../config';
import { googleMeasurementSecret } from './../utils/gaUtils';

class RegistrationInput extends Component {
  constructor(props) {
    super(props);
    this._handleOnBlur = this._handleOnBlur.bind(this);
  }

  _handleOnBlur(e) {
    const { validators } = this.props
    const { name, value } = e.target
    const validateFields = [{ name: name, value: value, validators: validators }]

    const isValid = this.props.handleValidate(validateFields)

    if (!isValid) {
      return false
    }
  }

  render() {
    const { name, value, placeholder, className } = this.props

    return (
      <Input name={name}
        placeholder={placeholder}
        value={value}
        block className={className}
        onChange={this.props.onChange}
        onBlur={this._handleOnBlur}
        lower
      />
    )
  }
}

class Registration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      fieldError: {},
      errors: [],
      scenario: '',
      isUpdating: false,
    };

    this._handleSubmit = this._handleSubmit.bind(this);
    this._handleValidate = this._handleValidate.bind(this);
    this._handleOnChange = this._handleOnChange.bind(this);

    this.isDebug = window.location.search.indexOf('?debug') === 0;
  }

  _handleOnChange(e) {
    const { name, value } = e.target;

    this.setState({
      [name]: value.trim()
    });
  }

  _handleSubmit(e) {
    e.preventDefault();

    const { history } = this.props;
    const { email, scenario } = this.state;

    const validateFields = [
      { name: 'email', value: email, validators: ['isRequired', 'isEmail'] },
    ];

    const isValid = this._handleValidate(validateFields);

    if (!isValid) {
      return false;
    }

    this.setState({ isUpdating: true });

    profileApi.userGeo().then(resp => {
      const query = JSON.parse(localStorage.getItem('query'));

      return Promise.resolve({
        user: {
          email: email.toLowerCase(),
          scenario_version: scenario,
          profile: {
            geoip_country_name: resp.country_name,
            geoip_country_code: resp.country_code,
            register_ip: resp.ip_address,
            landing_query: query.utm,
            landing: query.path,
            hostname: window.location.hostname,
          }
        }
      });
    }).then(data => {
      return profileApi.register(data).then(resp => {
        trackValues('stage', 'registration', {
          context: { validEmail: true, site_id: trackSiteId, userId: resp.id },
        });

        googleMeasurementSecret({ event: 'applicant_created', userId: resp.id })

        this.props.profileInvalidate();
        history.push('/success');
      })
    }).catch(error => {
      trackValues('stage', 'registration', {
        context: { validEmail: false, site_id: trackSiteId },
      });

      this.setState({
        errors: get(error, 'errors', []),
        isUpdating: false,
      });
    })
  }

  _handleValidate(validateFields) {
    const fieldError = validate(validateFields);

    this.setState({
      fieldError: fieldError,
    });

    return isEmpty(fieldError);
  }

  render() {
    const { email, fieldError, errors, scenario, isUpdating } = this.state
    const disabled = some({ email }, (item, key) => !item) || isUpdating;

    return (
      <div className={baseStyles.animate_form}>
        <div className={baseStyles.content} key='registration-intro'>
          {/* <h2 className={classnames(baseStyles.title_middle, baseStyles.mb_10)}>Ready to become a freelance research writer at Livingston
          Research? </h2>
          <p className={classnames(baseStyles.tutorial_subtitle, baseStyles.centered, baseStyles.mb_30)}>Let’s get started!</p> */}
          <h2 className={classnames(baseStyles.title_middle, baseStyles.mb_10)}>{RegistrationPageTitle}</h2>
          <p className={classnames(baseStyles.tutorial_subtitle, baseStyles.centered, baseStyles.mb_30)}>{RegistrationPageSubTitle}</p>
        </div>
        <div className={baseStyles.form_styles} key='registration-form'>
          <form onSubmit={this._handleSubmit} method='post'>
            <div className={baseStyles.form_field}>
              {this.isDebug &&
                <Input placeholder="scenario v0 v1 v2" name="scenario" value={scenario} onChange={this._handleOnChange} />
              }
              <div className={baseStyles.form_label_box}>
                <h4 className={baseStyles.form_label}>Your email</h4>
              </div>
              <RegistrationInput
                name="email"
                value={email}
                className={classnames({ [baseStyles.error]: fieldError.email || errors.length })}
                placeholder="Your email"
                onChange={this._handleOnChange}
                handleValidate={this._handleValidate}
                validators={['isRequired', 'isEmail']}
              />
              {fieldError.email && <h4 className={baseStyles.form_label_error}>{fieldError.email}</h4>}
              {!fieldError.email && errors.map((item, key) => <div key={key}
                className={classnames(baseStyles.text_danger)}>{item}</div>)}
            </div>

            <div className={baseStyles.form_field}>
              <Button type='submit' block disabled={disabled}>Create account</Button>
            </div>
          </form>

          <div className={baseStyles.form_links}>
            <Link to='/login'>I have an account</Link>
            {/* <NavLink className={baseStyles.link_devider} to='/login'>I have an account</NavLink>
          <Link to='/restore-password'>Restore password</Link> */}
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  profileInvalidate: () => (dispatch(profileInvalidate())),
})


export default connect(null, mapDispatchToProps)(Registration)



// WEBPACK FOOTER //
// ./src/components/PageRegistration.js